import React from 'react';
import { Link } from 'react-router-dom';

const ThankYouSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="text-center clearfix" style={{ padding: '40px 0', width: '100%' }}>
                            <div className="error" style={{ marginBottom: '30px' }}>
                                <i className="fa fa-check-circle" style={{ fontSize: '100px', color: '#28a745' }}></i>
                            </div>
                            <div style={{ width: '100%', padding: '0', maxWidth: '100%' }}>
                                <h3 style={{ marginBottom: '20px' }}>Registration Confirmed!</h3>
                                <p style={{ fontSize: '18px', marginBottom: '30px', color: '#555' }}>
                                    Thank you for securing your spot at <strong>The Cash Flow Summit 2026</strong>. <br/>
                                    Your payment was successful, and we have sent the event details to your email. We look forward to seeing you there!
                                </p>
                                <Link onClick={ClickHandler} to="/" className="theme-btn">Back to home</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ThankYouSection;